import { render, staticRenderFns } from "./DailyCoupon.vue?vue&type=template&id=e5dab6ae&scoped=true&"
import script from "./DailyCoupon.vue?vue&type=script&lang=js&"
export * from "./DailyCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DailyCoupon.vue?vue&type=style&index=0&id=e5dab6ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dab6ae",
  null
  
)

export default component.exports